module.exports = __webpack_public_path__ + "static/media/02.adde9e15.png";